import { disableScroll, enableScroll} from '../utils/scroll';

const body = document.querySelector('body');

export const showMenu = (navbarToggler, header, videoBg) => {
  videoBg && !videoBg.classList.contains('lazy') && videoBg.play();
  navbarToggler.classList.add('menu-open');
  if (body.classList.contains('dark')) {
    body.classList.remove('dark');
    body.classList.add('dark--remove');
  } 
  header.classList.add('show');
  disableScroll();
}

export const hideMenu = (navbarToggler, header, videoBg) => {
  videoBg && videoBg.pause();
  navbarToggler.classList.remove('menu-open');
  header.classList.remove('show');
  if (body.classList.contains('dark--remove')) {
    body.classList.remove('dark--remove');
    body.classList.add('dark');
  }
  enableScroll();
}

export const toggleMobileMenu = (navbarToggler, header, videoBg) => {
  if(!navbarToggler) return;
  navbarToggler.addEventListener('click', () => (!navbarToggler.classList.contains('menu-open')) ? showMenu(navbarToggler, header, videoBg) : hideMenu(navbarToggler, header, videoBg));
  document.addEventListener("keyup", (e) => (e.key === 'Escape' && document.body.classList.contains('disable-scroll')) && hideMenu(navbarToggler, header));
}

export const setStickyHeader = (header, offset) => (window.scrollY >= 100 || offset && offset.y >= 100 ? !header.classList.contains('sticky') && header.classList.add('sticky') : header.classList.contains('sticky') && header.classList.remove('sticky'));
